// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const NASP_TRACKER_ACTIONS = {

	// ── Get Nasp Tracker ──────────────────────────────────────────────────────
	NT_GET_NASP_TRACKER_REQUEST: 'NT_GET_NASP_TRACKER_REQUEST',
	NT_GET_NASP_TRACKER_SUCCESS: 'NT_GET_NASP_TRACKER_SUCCESS',
	NT_GET_NASP_TRACKER_FAILURE: 'NT_GET_NASP_TRACKER_FAILURE',

	// ── Get Nasp Tracker By Id ────────────────────────────────────────────────
	NT_GET_NASP_TRACKER_BY_ID_REQUEST: 'NT_GET_NASP_TRACKER_BY_ID_REQUEST',
	NT_GET_NASP_TRACKER_BY_ID_SUCCESS: 'NT_GET_NASP_TRACKER_BY_ID_SUCCESS',
	NT_GET_NASP_TRACKER_BY_ID_FAILURE: 'NT_GET_NASP_TRACKER_BY_ID_FAILURE',

	// ── Get Nasp Tracker Dropdowns ─────────────────────────────────────────────
	NT_GET_NASP_TRACKER_DROPDOWNS_REQUEST: 'NT_GET_NASP_TRACKER_DROPDOWNS_REQUEST',
	NT_GET_NASP_TRACKER_DROPDOWNS_SUCCESS: 'NT_GET_NASP_TRACKER_DROPDOWNS_SUCCESS',
	NT_GET_NASP_TRACKER_DROPDOWNS_FAILURE: 'NT_GET_NASP_TRACKER_DROPDOWNS_FAILURE',

	// ── Get Nasp Tracker History ──────────────────────────────────────────────
	NT_GET_NASP_TRACKER_HISTORY_REQUEST: 'NT_GET_NASP_TRACKER_HISTORY_REQUEST',
	NT_GET_NASP_TRACKER_HISTORY_SUCCESS: 'NT_GET_NASP_TRACKER_HISTORY_SUCCESS',
	NT_GET_NASP_TRACKER_HISTORY_FAILURE: 'NT_GET_NASP_TRACKER_HISTORY_FAILURE',

	// ── Update Nasp Tracker ───────────────────────────────────────────────────
	NT_UPDATE_NASP_TRACKER_REQUEST: 'NT_UPDATE_NASP_TRACKER_REQUEST',
	NT_UPDATE_NASP_TRACKER_SUCCESS: 'NT_UPDATE_NASP_TRACKER_SUCCESS',
	NT_UPDATE_NASP_TRACKER_FAILURE: 'NT_UPDATE_NASP_TRACKER_FAILURE',

	// ── Add Nasp Tracker Comment ──────────────────────────────────────────────
	NT_ADD_NASP_TRACKER_COMMENT_REQUEST: 'NT_ADD_NASP_TRACKER_COMMENT_REQUEST',
	NT_ADD_NASP_TRACKER_COMMENT_SUCCESS: 'NT_ADD_NASP_TRACKER_COMMENT_SUCCESS',
	NT_ADD_NASP_TRACKER_COMMENT_FAILURE: 'NT_ADD_NASP_TRACKER_COMMENT_FAILURE',

	// ── Export Nasp Tracker ───────────────────────────────────────────────────
	NT_EXPORT_NASP_TRACKER_REQUEST: 'NT_EXPORT_NASP_TRACKER_REQUEST',
	NT_EXPORT_NASP_TRACKER_SUCCESS: 'NT_EXPORT_NASP_TRACKER_SUCCESS',
	NT_EXPORT_NASP_TRACKER_FAILURE: 'NT_EXPORT_NASP_TRACKER_FAILURE',

};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Get Nasp Tracker
export const ntGetNaspTrackerRequest = (userFlag) => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_REQUEST, userFlag });
export const ntGetNaspTrackerSuccess = (payload, userFlag) => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_SUCCESS, payload, userFlag });
export const ntGetNaspTrackerFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_FAILURE, error });

// Get Nasp Tracker By Id
export const ntGetNaspTrackerByIdRequest = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_REQUEST });
export const ntGetNaspTrackerByIdSuccess = (payload) => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_SUCCESS, payload });
export const ntGetNaspTrackerByIdFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_BY_ID_FAILURE, error });

// Get Nasp Tracker Dropdowns
export const ntGetNaspTrackerDropdownsRequest = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_REQUEST });
export const ntGetNaspTrackerDropdownsSuccess = (payload) => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_SUCCESS, payload });
export const ntGetNaspTrackerDropdownsFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_DROPDOWNS_FAILURE, error });

// Get Nasp Tracker History
export const ntGetNaspTrackerHistoryRequest = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_REQUEST });
export const ntGetNaspTrackerHistorySuccess = (payload) => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_SUCCESS, payload });
export const ntGetNaspTrackerHistoryFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_GET_NASP_TRACKER_HISTORY_FAILURE, error });

// Update Nasp Tracker
export const ntUpdateNaspTrackerRequest = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_REQUEST });
export const ntUpdateNaspTrackerSuccess = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_SUCCESS });
export const ntUpdateNaspTrackerFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_UPDATE_NASP_TRACKER_FAILURE, error });

// Add Nasp Tracker Comment
export const ntAddNaspTrackerCommentRequest = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_REQUEST });
export const ntAddNaspTrackerCommentSuccess = ()        => ({ type: NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_SUCCESS });
export const ntAddNaspTrackerCommentFailure = (error)   => ({ type: NASP_TRACKER_ACTIONS.NT_ADD_NASP_TRACKER_COMMENT_FAILURE, error });

// Export Nasp Tracker
export const ntExportNaspTrackerRequest = ()      => ({ type: NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_REQUEST });
export const ntExportNaspTrackerSuccess = ()      => ({ type: NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_SUCCESS });
export const ntExportNaspTrackerFailure = (error) => ({ type: NASP_TRACKER_ACTIONS.NT_EXPORT_NASP_TRACKER_FAILURE, error });